import React from 'react';
import {
  SecondaryNavContainer,
  SecondaryNavLinks,
} from '../../../components/SecondaryNav';
import { incidentNavLinks } from './utils';

const IncidentNav = () => (
  <SecondaryNavContainer heading={'Incident'}>
    <SecondaryNavLinks links={incidentNavLinks} />
  </SecondaryNavContainer>
);

export default IncidentNav;
